import { API } from "@aws-amplify/api";
import { API_NAME } from "../constants";

function AdverseEffects(centerId) {
  let path = "/adverseeffects/" + centerId;
  return API.get(API_NAME, path);
}

export default AdverseEffects;
